<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import MarkdownPage from "@components/MarkdownPage.vue";

const route = useRoute();
const slug = computed(() => `sweeps-rules-${route.params.lang}`);
</script>

<template>
    <Transition name="panel" appear>
        <MarkdownPage :key="slug" :slug="slug" />
    </Transition>
</template>
